// ABOUTME: Inline chat card rendered when a publish_completed Notification
// arrives via /events/stream. Shows '✅ Posted to {platform} at {time}'
// with an optional link to the live post. Closes the loop so the SMB owner
// sees their draft go live without leaving the chat.

import { CheckCircle2, ExternalLink } from 'lucide-react'
import { cn } from '@/lib/utils'
import { CHAT_CARD } from '@/components/chat/chatCard'
import { getPlatformBrand } from '@/lib/platforms'

interface PostedConfirmationProps {
  platform: string
  postUrl?: string | null
  postedAt: string
}

export function PostedConfirmation({ platform, postUrl, postedAt }: PostedConfirmationProps) {
  const brand = getPlatformBrand(platform)
  const time = (() => {
    try {
      return new Date(postedAt).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
    } catch {
      return postedAt
    }
  })()

  return (
    <div data-testid="posted-confirmation" className={cn(CHAT_CARD, 'my-2')}>
      <div className="flex items-center gap-2">
        <CheckCircle2 className="text-success size-4 shrink-0" />
        <span className="flex-1 text-xs">
          Posted to <span className="font-medium">{brand.label}</span> at{' '}
          <span className="font-medium">{time}</span>
        </span>
        {postUrl && (
          <a
            href={postUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary inline-flex items-center gap-1 text-xs font-medium underline underline-offset-2"
            data-testid="posted-confirmation-link"
          >
            View post
            <ExternalLink className="size-3" />
          </a>
        )}
      </div>
    </div>
  )
}
